export enum ButtonType {
  Green,
  White,
  Black,
  BlackFloating,
  BlackPrimary,
}
